<template>
  <v-container grid-list-lg>
    <v-layout class="check-in-client" justify-center align-center row wrap>
      <v-flex v-if="filteredClients.length > 1">
        <div class="check-in-client__multiple">
          Please select the correct profile to login with.
        </div>
      </v-flex>
      <v-flex v-if="filteredClients.length > 0" xs10 class="check-in-client__cards" v-for="(client) in filteredClients" :key="client.Id">
        <check-in-client-card :client="client" @openScheduler="openScheduler" @selectDate="selectDate"/>
      </v-flex>
      <v-flex v-if="filteredClients.length === 0" xs10 class="check-in-client__cards">
        <check-in-client-empty-card @openScheduler="openNewClientScheduler"></check-in-client-empty-card>
      </v-flex>
    </v-layout>
    <scheduler-modal
      :showDialog="showScheduler"
      @selectDate="selectDate"
      @close="closeScheduler">
    </scheduler-modal>
    <new-client-quick-modal
      :showDialog="showNewClient"
      :phone="phone"
      @close="closeNewClientDialog"
      @saved="savedClient">
    </new-client-quick-modal>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import appointmentService from '@/framework/appointment/appointmentService'
import clientService from '@/framework/client/clientService'
import CheckInClientCard from './checkInClientCard.vue'
import CheckInClientEmptyCard from './checkInClientEmptyCard.vue'
import NewClientQuickModal from '@/views/client/newClientQuickModal.vue'
import SchedulerModal from '@/views/scheduler/schedulerModal.vue'
import moment from 'moment'

export default {
  components: {
    CheckInClientCard,
    CheckInClientEmptyCard,
    NewClientQuickModal,
    SchedulerModal
  },
  data: () => {
    return {
      isNewClient: false,
      selectedAppointment: undefined,
      showNewClient: false,
      showScheduler: false
    }
  },
  computed: {
    filteredClients () {
      if (!this.selectedClient) {
        return this.clients
      }
      return this.clients.filter(c => c.Id === this.selectedClient.Id)
    },
    ...mapGetters({
      clients: 'checkIn/getClients',
      location: 'user/getLocation',
      phone: 'checkIn/getPhone',
      selectedClient: 'checkIn/getSelectedClient'
    })
  },
  methods: {
    closeNewClientDialog () {
      this.showNewClient = false
    },
    closeScheduler () {
      this.showScheduler = false
    },
    openNewClientScheduler () {
      if (this.location.schedule_type === 'schedule.queue') {
        const today = moment().format('YYYY-MM-DD')
        const time = moment().add('min', 1).format('HH:mm')
        this.selectedAppointment = { date: today, time: time }
        this.showNewClient = true
      } else if (this.location.schedule_type === 'schedule.kartThirty') {
        // TODO: need to change schedule modal to force a limit of a specific date.
        throw new Error('NEED IMPLEMENT KART BOOKING FROM CHECKIN')
      } else {
        this.showScheduler = true
        this.isNewClient = true
      }
    },
    openScheduler () {
      this.showScheduler = true
      this.isNewClient = false
    },
    async savedClient (res) {
      let date = this.selectedAppointment.date.split('T')[0]
      
      await clientService.bookAppointment({ clientId: res.Id, locationId: this.location.id, date: date, time: this.selectedAppointment.time })

      let query = {
        phone: res.phone
      }
      clientService.searchByPhone(query).then(res => {
        if (res.data) {
          this.$store.commit('checkIn/updateClients', res.data)
        }
      }).catch(() => {
        this.openSnackbar('There was an issue searching appointments', 'error')
      })
    },
    selectDate (appointmentSlot, date) {
      this.selectedAppointment = appointmentSlot
      if (this.isNewClient) {
        this.showNewClient = true
      } else {
        clientService.bookAppointment({ clientId: this.selectedClient.Id, locationId: this.location.id, date: date, time: appointmentSlot.time }).then(res => {
          if (res.data) {
            if (this.location.schedule_type === 'schedule.queue') {
              appointmentService.checkInClient({ id: res.data, clientId: this.selectedClient.Id })
            }
            // this is a hack. need to find a better solution
            this.selectedClient.refresh++
          }
        }).catch(err => {
          this.openSnackbar('There was an issue creating your appointment. Please see an technician', 'error')
        })
      }
    }
  }
}
</script>

<style lang="scss">
.check-in-client {
  &__multiple {
    font-size: 1.4em;
    font-weight: 400;
    text-align: center;
  }
}
</style>
